import { useState, useCallback, useEffect } from "react";
import ThemeContext from "./ThemeContext";

const ThemeProvider = ({ children }) => {
  const [themeMode, setThemeMode] = useState("dark");

  const setMode = useCallback((mode) => {
    window.localStorage.setItem("Theme Mode", mode);
    setThemeMode(mode);
  }, []);

  const handleChangeTheme = useCallback(() => {
    setThemeMode((prev) => (prev === "light" ? "dark" : "light"));
    if (themeMode === "light") {
      setMode("dark");
    } else {
      setMode("light");
    }
  }, [themeMode, setMode]);

  useEffect(() => {
    const localTheme = window.localStorage.getItem("Theme Mode");
    if (localTheme) {
      setThemeMode(localTheme);
    } else {
      setThemeMode("light");
      window.localStorage.setItem("Theme Mode", "light");
    }
  }, [themeMode]);

  return (
    <ThemeContext.Provider value={{ themeMode, handleChangeTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
